import { Spin } from 'antd';

import { AnimationCanvas } from '@suntex.core/animation';
import { Constructor } from '@suntex.core/types';

import { PlayerBadge as initPlayerBadgeGraphics } from '../createjs/PlayerBadge';
import {
  PlayerBadgeExportRoot,
  renderPlayerBadge,
} from '../display/renderPlayerBadge';

export function PlayerAvatar({
  params,
  flatten,
}: {
  params?: {
    stickers: number;
    badgeIcon: number;
    badgeBackground: number;
  };
  flatten?: boolean;
}) {
  const width = 190;
  const height = 200;

  return !params ? (
    <div
      style={{
        width,
        height,
      }}
    >
      <Spin />
    </div>
  ) : (
    <AnimationCanvas
      {...{
        width,
        height,
        compositionId: 'B8DEB2847161C640B28373DD93571676',
        deps: [
          params.stickers,
          params.badgeIcon,
          params.badgeBackground,
          flatten,
        ],
        transformImageSource: (src) => fimCdnAnimateUrl(src),
        initGraphics: (cjs, an) => {
          initPlayerBadgeGraphics(cjs, an);
        },
        onReady: ({ stage, lib }) => {
          const PlayerBadgeExportRootConstructor =
            lib.PlayerBadge as Constructor<PlayerBadgeExportRoot, []>;
          const exportRoot = new PlayerBadgeExportRootConstructor();
          stage.addChild(exportRoot);
          renderPlayerBadge(exportRoot, {
            stickers: params.stickers,
            icon: params.badgeIcon,
            background: params.badgeBackground,
            flatten,
          });
        },
      }}
    />
  );
}

function fimCdnAnimateUrl(src: string): string {
  src = src.trim().replace(/^\//, '');
  return `https://cdn.firstinmath.com/content/animate/live/${src}`;
}
